"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.safeParseJson = safeParseJson;
function safeParseJson(jsonString) {
  try {
    return JSON.parse(jsonString);
  } catch (e) {
    return null;
  }
}